<template>
    <section>
      <div class="container" v-if="addOns.questionnaires">
        <div class="hero is-bold">
          <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
            <div class="container">
              <h1 class="title" style="color:#3e8ed0">Questionnaires</h1>
              <h4 class="subtitle">Manage your questionnaires here.</h4>
            </div>
          </div>
        </div>

        <div class="columns is-multiline is-mobile">
          <div class="column is-4 is-offset-1 box" border-width="thick" v-for="(questionnaire, questionnaireId) in questionnaires" :key="questionnaireId">
            <div class="level" >
              <div class="level-left">
              <div style="font-size:17.5px;color:#3e8ed0;cursor:pointer" class="level-item" @click="editQuestionnaire(questionnaireId)"><b>{{showQuestionnaireName(questionnaire.name)}}</b></div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <b-button icon-left="edit" class="button is-info" @click="editQuestionnaire(questionnaireId)"
                  >Edit</b-button>
                </div>
                <div class="level-item">
                  <b-button icon-left="trash" class="button is-danger" @click="confirmRemove(questionnaireId, questionnaire.name)"
                  :disabled="role === 'viewer'"></b-button>
                </div>
              </div>
            </div>
              <p><b>Number of questions:</b> {{questionnaire.questions ? Object.keys(questionnaire.questions).length : 'N/A'}}</p>
          </div>
        <div></div>
        </div>
        <vue-fab v-if="!bQuestionnaireAdd" title="Add Questionnaire" :scrollAutoHide="autoHide" mainBtnColor="#48c78e" icon="add" size="big" @clickMainBtn="addQuestionnaire" :hidden="role === 'viewer'"/>
      </div>
    </section>
  </template>
<script>
import QuestionnaireAddEdit from '@/components/questionnaires/QuestionnaireAddEdit'

export default {
  name: 'Questionnaires',
  data: () => {
    return {
      bQuestionnaireAdd: false,
      autoHide: true
    }
  },
  computed: {
    questionnaires () {
      return this.$store.state.questionnaires
    },
    addOns () {
      return this.$store.state.addOns
    },
    role () {
      return this.$store.state.role
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    userId () {
      return this.$store.state.uid
    }
  },
  methods: {
    addQuestionnaire () {
      this.bQuestionnaireAdd = true
      this.$buefy.modal.open({
        parent: this,
        component: QuestionnaireAddEdit,
        props: { propParentFn: this.cancelAdd },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
    },
    editQuestionnaire (id) {
      this.bQuestionnaireAdd = true
      this.$buefy.modal.open({
        parent: this,
        component: QuestionnaireAddEdit,
        props: { editEnabled: true, propId: id, propParentFn: this.cancelAdd },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
    },
    confirmRemove (id, name) {
      this.$buefy.dialog.confirm({
        title: 'Delete questionnaire',
        message: 'Are you sure that you want to <b>delete</b> questionnaire "' + name + '"?',
        confirmText: 'Delete',
        type: 'is-danger',
        onConfirm: () => {
          let removeQuestionnaireRef = null
          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
            removeQuestionnaireRef = this.$store.state.database.ref('/neoslide/questionnaires/' + this.workspaceId + '/' + id)
          } else {
            removeQuestionnaireRef = this.$store.state.database.ref('/questionnaires/' + this.userId + '/' + id)
          }
          removeQuestionnaireRef.remove()
        }
      })
    },
    cancelAdd () {
      this.bQuestionnaireAdd = false
    },
    showQuestionnaireName (name) {
      if (name.length > 21) {
        return name.substr(0, 21) + '...'
      }
      return name
    }
  }
}
</script>

<style scoped>
  .box {
    border: 0.5px solid rgb(212, 212, 212);
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/Questionnaires.vue